<script setup>
import { computed } from 'vue';
import { mdiYoutube, mdiOpenInNew } from '@mdi/js';
import { youTubeWatchUrl, safeHttpUrl } from '../../domain/video.js';

/* Einheitlicher Knopf für Highlight- und Match-Links (SectorMaterial.vue).
 *
 * YouTube-Adressen: ein ECHTER Link (a href) auf die normale Adresse https://www.youtube.com/watch?v=…, mit
 * target="_blank" und rel="noopener noreferrer". Das lässt das Handy die YouTube-App öffnen, wenn sie installiert ist,
 * sonst den Browser. Kein eingebetteter Player, kein Fenster in der App, kein App-Schema (vnd.youtube:), kein Skript,
 * das die Adresse später öffnet — der Link wird durch den echten Klick selbst ausgelöst (F4, Teil B).
 * Alles andere fällt auf "Open link" zurück, aber nur mit http(s)-Adresse (kein javascript: aus gespeicherten Daten).
 * Zweimal im gleichen Bau gebraucht (Highlight-Slot, Match-Liste) — deshalb eigene Komponente statt Duplikat.
 */

const props = defineProps({
  url: { type: String, required: true },
});

const watchUrl = computed(() => youTubeWatchUrl(props.url));
const otherUrl = computed(() => (watchUrl.value ? '' : safeHttpUrl(props.url)));
</script>

<template>
  <a
    v-if="watchUrl"
    class="icon-btn play-btn"
    :href="watchUrl"
    target="_blank"
    rel="noopener noreferrer"
    data-testid="video-link"
  >
    <v-icon :icon="mdiYoutube" size="16" />
    {{ $t('material.playVideo') }}
    <!-- Umriss-Symbol "öffnet extern" -->
    <v-icon :icon="mdiOpenInNew" size="14" class="ext-icon" aria-hidden="true" />
  </a>
  <a
    v-else-if="otherUrl"
    class="icon-btn"
    :href="otherUrl"
    target="_blank"
    rel="noopener noreferrer"
    data-testid="video-link"
  >
    {{ $t('material.openLink') }}
  </a>
</template>

<style scoped>
/* Ein Link sieht aus wie der frühere Knopf: keine Unterstreichung */
a.icon-btn {
  text-decoration: none;
}
.play-btn {
  display: inline-flex;
  align-items: center;
  gap: 4px;
}
.ext-icon {
  opacity: 0.7;
}
</style>
